export class Code {
  constructor(difference) {
    this.width = 200
    this.height = 200
    this.top = 0
    this.left = 0
    this.innerElement = "cxCode"
    this.content = "二维码"
    this.internalLinkName = ""
    this.bgColor = "rgba(255, 255, 255, 0)"
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.codeColor = "rgba(0,0,0,1)"
    this.codeColorIsTheme = false
    this.opacity = 1
    this.rotate = 0
    this.linkUrlVal = ""
    this.internalLinkName = ""
    this.linkAddressVal = "默认"
    this.accessRulers = []
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
